export default function CatalogSection() {
  const catalogUrl = "/downloads/Productcatalogus Fourshop maart 2026.pdf";

  return (
    <section id="catalogus" className="py-16 bg-white/10 backdrop-blur-xs">
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-linear-to-r from-white/20 to-white/10 rounded-xl p-8 border border-white/30">
            <div className="w-16 h-16 bg-teal-400 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-file-list-3-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">
              Digitale productcatalogus
            </h3>
            <p className="text-white/90 mb-6">
              Bekijk ons volledige aanbod in onze digitale catalogus. Download
              de PDF gratis en bekijk alle producten op uw gemak.
            </p>
            <a
              href={catalogUrl}
              download="Productcatalogus Fourshop maart 2026.pdf"
              className="inline-flex items-center gap-2 bg-white text-teal-600 font-semibold px-6 py-3 rounded-lg hover:bg-teal-50 transition-colors shadow-lg"
            >
              <i className="ri-download-line text-xl"></i>
              Catalogus downloaden (PDF)
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
